import React from 'react';
import { Check } from 'lucide-react';
import { mockData } from '../../mock';

const SocialProof = () => {
  return (
    <section className="py-16 px-6 bg-gradient-to-b from-[#0a0a0a] to-[#111111] border-y border-gray-800/50">
      <div className="container mx-auto max-w-6xl">
        {/* Statistics */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          <div className="text-center">
            <div className="text-4xl font-bold text-[#2F6BFF] mb-2">20+</div>
            <div className="text-sm text-[#9AA3B2]">Projects Completed</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-[#2F6BFF] mb-2">100%</div>
            <div className="text-sm text-[#9AA3B2]">Client Satisfaction</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-[#2F6BFF] mb-2">48hr</div>
            <div className="text-sm text-[#9AA3B2]">Average Response</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-[#2F6BFF] mb-2">2yrs</div>
            <div className="text-sm text-[#9AA3B2]">Experience</div>
          </div>
        </div>
        
        {/* Trust Badges */}
        <div className="flex flex-wrap justify-center gap-4 mb-8">
          <div className="inline-flex items-center justify-center gap-2 px-4 py-2 h-10 bg-[#2F6BFF]/10 rounded-full border border-[#2F6BFF]/20">
            <Check className="h-4 w-4 text-[#2F6BFF] flex-shrink-0" />
            <span className="text-sm font-medium text-[#F5F7FF] whitespace-nowrap">100% Satisfaction Guarantee</span>
          </div>
          <div className="inline-flex items-center justify-center gap-2 px-4 py-2 h-10 bg-[#2F6BFF]/10 rounded-full border border-[#2F6BFF]/20">
            <Check className="h-4 w-4 text-[#2F6BFF] flex-shrink-0" />
            <span className="text-sm font-medium text-[#F5F7FF] whitespace-nowrap">Free Revisions Included</span>
          </div>
          <div className="inline-flex items-center justify-center gap-2 px-4 py-2 h-10 bg-[#2F6BFF]/10 rounded-full border border-[#2F6BFF]/20">
            <Check className="h-4 w-4 text-[#2F6BFF] flex-shrink-0" />
            <span className="text-sm font-medium text-[#F5F7FF] whitespace-nowrap">Quick Turnaround</span>
          </div>
        </div>

        <p className="text-center text-sm text-[#9AA3B2] mb-8">Trusted by service businesses across London</p>
        <div className="flex flex-wrap justify-center gap-8 text-gray-500 text-sm">
          {mockData.trustedIndustries.map((industry, index) => (
            <span key={index} className="flex items-center gap-2 hover:text-[#2F6BFF] transition-colors duration-300">
              <Check className="h-3 w-3 text-[#2F6BFF]" />
              {industry}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SocialProof;
